const MobileMenu = ({ pages, toggleClicked, handleRoute }) => {
    return (
        <div className="fixed inset-0 flex items-center justify-center z-100">
            <div className="relative bg-background p-5 rounded-md w-full h-full mt-40">
                <span className="absolute top-0 py-2 right-2.5 cursor-pointer text-white text-xl px-2" onClick={() => toggleClicked(false)}>
                    &times;
                </span>
                <div className="grid grid-cols-1 m-4 gap-4 rounded-xl">
                    {
                        pages.map((each, i) => {
                            return (
                                <button onClick={() => handleRoute(i)} key={i} className="w-full hover:-translate-y-1 transition-transform transform px-6 py-2 text-primary text-lg font-semibold capitalize bg-transparent border rounded-xl border-secondary hover:bg-secondary hover:cursor-pointer">
                                    {each}
                                </button>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    )
}

export default MobileMenu;
